import { createReducer, INITIAL_STATE } from '../../../shared/redux';
import { Action, State } from './subdomain-types';

export const MAIN_INCREMENT = '@pricing/MAIN_INCREMENT';
export const MAIN_DECREMENT = '@pricing/MAIN_DECREMENT';

export const getCount = state => state.pricing.subdomain.counter;

export const increment = ():Action => ({
  type: MAIN_INCREMENT
});

export const decrement = ():Action => ({
  type: MAIN_DECREMENT
});

export const getUpdatedCount = (amount: number) => (state: State) => ({
  ...state, 
  counter: state.counter + amount
})

const initialState: State = {
  counter: 0
};

export const subdomainReducer = createReducer({
  [INITIAL_STATE]: initialState,
  [MAIN_INCREMENT]: getUpdatedCount(1),
  [MAIN_DECREMENT]: getUpdatedCount(-1),
});